import type React from 'react';

import { MovementStaffDrawer } from '../components/MovementStaffDrawer';
import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	return (
		<>
			<MovementStaffDrawer />
			<div className="container pb-10">
				<PageHeading />
				<PageBody />
			</div>
		</>
	);
};
